import React, { useState, useEffect } from "react";
import leftPng from "../../../../content/images/left.png";
import $ from "jquery";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";

const Edit = () => {
  const [selectKosteneenheid, handleSelectKosteneenheid] = useState(false);

  useEffect(() => {
    $(document).on("click", ".popuptext-dropdown-a", function () {
      $("#" + $(this).attr("name") + "-select").val($(this).text());
      $("#" + $(this).attr("name") + "-select");
      var test = $("#" + $(this).attr("name"));
      test[0].childNodes.forEach((element) => {
        element.className = "popuptext-dropdown-a";
      });
      $(this).attr("class", "popuptext-dropdown-a-selected");

      if ($(this).attr("name") === "e-algemeen-kosteneenheid") {
        handleSelectKosteneenheid(!selectKosteneenheid);
      }
    });
  });

  const handleSubmit = async () => {
    $("#cover-spin").show(0);
    var actief = $("#e-work_resources_active").is(":checked")
      ? (actief = true)
      : (actief = false);
    var naam = $("#e-algemeen-naam").val();
    var code = $("#e-algemeen-code").val();
    var omschrijving = $("#e-algemeen-omschrijving").val();
    var prijs = $("#e-algemeen-prijs").val();
    var kosteneenheid = $("#e-algemeen-kosteneenheid-select").val();

    var id = $("#e-identification").val();
    var model = {
      content: {
        algemeen: {
          code: code,
          naam: naam,
          actief: actief,
          omschrijving: omschrijving,
          kosteneenheid: kosteneenheid,
          prijs: prijs,
        },
      },
      identification: id,
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [code],
        },
      ],
      definitions: [process.env.REACT_APP_CATALOG_WORK_RESOURCES],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then(async (result) => {
        if (
          result.data &&
          result.data.length > 0 &&
          result.data[0].identification !== id
        ) {
          isUnique = await false;
          $("#cover-spin").hide(0);

          alert("code is not unique");
        }
      });

    if (isUnique) {
      omnimap
        .SaveOrEditAction(
          model,
          "PATCH",
          id,
          window.$catalog_management_units_token
        )
        .then((data) => {
          if (data.result.status === "OK") {
            CallBackFunctions.WerkbronEditCallBack(
              window.$catalog_management_units_token
            );
          }
        });
    }
  };

  return (
    <div id="editSide" className="d-none">
      <div className="detail-title">Werkbronnen in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Werkbronnen
          </a>
        </div>
        <div className="float-right mt-0">
          <a
            onClick={handleSubmit}
            id="edit_work_resources"
            className="button ok"
          >
            Opslaan
          </a>
        </div>
        <div className="float-right mt-0 w-20">
          <a id="return-detail" className="button back">
            Annuleren
          </a>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam werkplan</div>
            <div className="box-title-2-active">
              <input id="e-algemeen-naam" autocomplete="off" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Code</div>
            <div className="box-title-2">
              <input id="e-algemeen-code" autocomplete="off" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Omschrijving</div>
            <div className="box-title-2">
              <input id="e-algemeen-omschrijving" autocomplete="off" />
            </div>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Kosteneenheid</div>
            <div
              className={
                selectKosteneenheid
                  ? "box-title-2 select-content open"
                  : "box-title-2 select-content"
              }
              onClick={() => handleSelectKosteneenheid(!selectKosteneenheid)}
            >
              <input
                id="e-algemeen-kosteneenheid-select"
                type="button"
                className="edit-dropdown"
              />
              <div class="popup-dropdown">
                <span
                  className={
                    selectKosteneenheid
                      ? "popuptext-dropdown show"
                      : "popuptext-dropdown"
                  }
                  id="e-algemeen-kosteneenheid"
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Actief</div>
            <label className="switch">
              <input id="e-work_resources_active" type="checkbox" />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Prijs</div>
            <div className="box-title-2">
              <input id="e-algemeen-prijs" type="number" step="any" />
            </div>
          </div>
        </div>
      </div>

      <input hidden="true" id="e-identification" />
    </div>
  );
};

export default Edit;
